<!--=============================
=            BARLINE            =
==============================-->
<template>
  <div id="echart12" style="height:300px;"></div>
</template>

<script>
  export default {

    mounted() {

      var chartDom = document.getElementById('echart12');
      var myChart = echarts.init(chartDom);
      var option;

      var xAxisData = [];
      var data1 = [];
      var data2 = [];
      for (var i = 0; i < 100; i++) {
        xAxisData.push('A' + i);
        data1.push((Math.sin(i / 15) * (i / 5 - 10) + i / 16) * 5);
        data2.push((Math.cos(i / 15) * (i / 5 - 10) + i / 16) * 5);
      }
      option = {
        title: {
          show: false
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false,
          // y: 'bottom',
          feature: {
            magicType: {
              type: ['stack']
            },
            dataView: {},
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {},
        xAxis: {
          data: xAxisData,
          splitLine: {
            show: false
          }
        },
        yAxis: {},
        series: [{
            name: 'bar',
            data: data1,
            type: 'line',
            symbolSize: 10,
            symbol: 'circle',
            color: '#006767',
            smooth: true,
            lineStyle: {
              width: 3,
              shadowColor: 'rgba(0,0,0,0.3)',
              shadowBlur: 10,
              shadowOffsetY: 8
            },
            emphasis: {
              focus: 'series'
            },
            animationDelay: function (idx) {
              return idx * 10;
            }
          },
          {
            name: 'bar2',
            type: 'bar',
            data: data2,
            symbolSize: 10,
            symbol: 'circle',
            smooth: true,
            color: '#ccdbdd',
            lineStyle: {
              width: 3,
              shadowColor: 'rgba(0,0,0,0.3)',
              shadowBlur: 10,
              shadowOffsetY: 10
            },
            emphasis: {
              focus: 'series'
            },
            animationDelay: function (idx) {
              return idx * 10 + 100;
            }
          }
        ],
        animationEasing: 'elasticOut',
        animationDelayUpdate: function (idx) {
          return idx * 5;
        }
      };

      option && myChart.setOption(option);
    }
  }
</script>


<!--====  End of BARLINE  ====-->